(function () {
  var page = document.querySelector("[data-academy-page]");
  if (!page || page.__academyReady) return;
  page.__academyReady = true;
  page.classList.add("shf-academy--js");

  var sent = {};

  function params(extra) {
    var query = new URLSearchParams(window.location.search);
    return Object.assign({
      page_name: "shufooni_barber_courses",
      page_path: window.location.pathname,
      page_location: window.location.href,
      utm_source: query.get("utm_source") || "",
      utm_campaign: query.get("utm_campaign") || "",
      utm_content: query.get("utm_content") || "",
      utm_medium: query.get("utm_medium") || ""
    }, extra || {});
  }

  function emit(name, data) {
    var payload = params(data);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));

    if (typeof window.gtag === "function") {
      window.gtag("event", name, payload);
    }

    if (typeof window.fbq === "function") {
      window.fbq("trackCustom", name, payload);
    }
  }

  function emitOnce(key, name, data) {
    if (sent[key]) return;
    sent[key] = true;
    emit(name, data);
  }

  function initRevealAndStageViews() {
    var revealItems = Array.prototype.slice.call(page.querySelectorAll("[data-academy-reveal]"));
    var stages = Array.prototype.slice.call(page.querySelectorAll("[data-academy-stage]"));

    if (!("IntersectionObserver" in window)) {
      revealItems.forEach(function (item) { item.classList.add("is-visible"); });
      stages.forEach(function (stage) {
        emitOnce("stage:" + stage.getAttribute("data-academy-stage"), "shufooni_academy_section_view", {
          section_name: stage.getAttribute("data-academy-stage")
        });
      });
      return;
    }

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.16 });

    revealItems.forEach(function (item) { revealObserver.observe(item); });

    var stageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var sectionName = entry.target.getAttribute("data-academy-stage") || "unknown";
        emitOnce("stage:" + sectionName, "shufooni_academy_section_view", {
          section_name: sectionName,
          visible_ratio: Math.round(entry.intersectionRatio * 100)
        });
      });
    }, { threshold: [0.34] });

    stages.forEach(function (stage) { stageObserver.observe(stage); });
  }

  function initSticky() {
    var sticky = page.querySelector("[data-academy-sticky]");
    if (!sticky) return;

    function update() {
      var show = window.innerWidth < 900 && window.scrollY > Math.min(620, window.innerHeight * 0.56);
      page.classList.toggle("is-sticky-visible", show);
    }

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function initClicks() {
    page.addEventListener("click", function (event) {
      var cta = event.target.closest("[data-academy-cta]");
      if (cta) {
        emit("shufooni_academy_cta_click", {
          cta_name: cta.getAttribute("data-academy-cta") || "",
          cta_text: cta.textContent.trim(),
          cta_target: cta.getAttribute("href") || ""
        });
      }

      var trackChoice = event.target.closest("[data-track-choice]");
      if (trackChoice) {
        var select = page.querySelector('[data-academy-lead-form] select[name="track"]');
        if (select) {
          select.value = trackChoice.getAttribute("data-track-choice") === "קורס נוער"
            ? "קורס נוער 13-17"
            : "קורס ספרות גברים 18+";
        }
      }

      var video = event.target.closest("[data-academy-video]");
      if (video) {
        emit("shufooni_academy_video_engage", {
          video_title: video.getAttribute("data-academy-video") || ""
        });
      }
    });

    page.querySelectorAll("details").forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (!item.open) return;
        var summary = item.querySelector("summary");
        emit("shufooni_academy_faq_open", {
          question: summary ? summary.textContent.trim() : ""
        });
      });
    });
  }

  function initLazyVideos() {
    var videos = Array.prototype.slice.call(page.querySelectorAll("[data-youtube-id]"));

    videos.forEach(function (card) {
      var trigger = card.querySelector(".shf-academy__video-thumb");
      var youtubeId = card.getAttribute("data-youtube-id");
      if (!trigger || !youtubeId) return;

      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        if (card.classList.contains("is-loaded")) return;

        var iframe = document.createElement("iframe");
        iframe.src = "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(youtubeId) + "?autoplay=1&rel=0&modestbranding=1";
        iframe.title = card.getAttribute("data-academy-video") || "Shufooni academy video";
        iframe.loading = "lazy";
        iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        iframe.allowFullscreen = true;

        trigger.replaceWith(iframe);
        card.classList.add("is-loaded");
      });
    });
  }

  function clean(value) {
    return (value || "").replace(/\s+/g, " ").trim();
  }

  function initLeadForm() {
    var form = page.querySelector("[data-academy-lead-form]");
    if (!form) return;
    var error = form.querySelector("[data-academy-form-error]");

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      var data = new FormData(form);
      var name = clean(data.get("name"));
      var phone = clean(data.get("phone"));
      var track = clean(data.get("track"));
      var experience = clean(data.get("experience"));
      var goal = clean(data.get("goal"));

      if (!name || !phone || !track || !experience) {
        if (error) {
          error.hidden = false;
          error.textContent = "חסרים כמה פרטים קצרים כדי לפתוח הודעה מסודרת בוואטסאפ.";
        }
        emit("shufooni_academy_form_error", { reason: "missing_required" });
        return;
      }

      if (error) {
        error.hidden = true;
        error.textContent = "";
      }

      var message = [
        "היי שופוני, אשמח לשיחת התאמה לקורס ספרות גברים.",
        "שם: " + name,
        "טלפון: " + phone,
        "מסלול שמעניין אותי: " + track,
        "רקע קודם: " + experience,
        goal ? "המטרה שלי: " + goal : "",
        "הגעתי מדף הקורסים באתר shufooniandsons.com"
      ].filter(Boolean).join("\n");

      emit("shufooni_academy_lead_submit", {
        lead_track: track,
        lead_experience: experience
      });

      var waPhone = form.getAttribute("data-whatsapp-phone") || "972533906811";
      window.location.href = "https://wa.me/" + waPhone + "?text=" + encodeURIComponent(message);
    });
  }

  function initScrollDepth() {
    var marks = [25, 50, 75, 90];
    var ticking = false;

    function check() {
      ticking = false;
      var doc = document.documentElement;
      var max = Math.max(1, doc.scrollHeight - window.innerHeight);
      var current = Math.round((window.scrollY / max) * 100);
      marks.forEach(function (mark) {
        if (current >= mark) {
          emitOnce("scroll:" + mark, "shufooni_academy_scroll_depth", {
            scroll_depth: mark
          });
        }
      });
    }

    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }, { passive: true });
    check();
  }

  emitOnce("view", "shufooni_academy_view", {
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight
  });
  initRevealAndStageViews();
  initSticky();
  initClicks();
  initLazyVideos();
  initLeadForm();
  initScrollDepth();
})();
